export const EDIT_REDIRECT_HEADER_TITLE = 'Edit Redirect';
export const ADD_REDIRECT_HEADER_TITLE = 'Create Redirect';
